import _ from 'lodash';
import moment from 'moment';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import FMPHeadline from '../../components/ui/FMPHeadline';
import TrueUpInvoicesContainer from '../../containers/accounting/TrueUpInvoices';
import EnhancedTableHead from '../../components/EnhancedTableHead';
//import InvoiceDocumentIcon from '../../components/ui/invoiceDocumentIcon';
import InvoiceDocumentPopup from '../../components/Dialogs/InvoiceDocumentPopup';
import InvoicePdfPopup from '../../components/Dialogs/InvoicePdfPopup';
import invoiceIcon from "../../images/invoicePdf.svg";
import quickbooksLogo from "../../images/quickbooksLogo.svg";

import {isFiltered, sortTable, PureRecordRow} from '../../libs/utility';
import Typography from "@material-ui/core/Typography";
import InvoiceDocumentIcon from "../../components/ui/invoiceDocumentIcon";

const invoiceStatusClassNames = {
	pending : {
		fontWeight : 900,
		color : '#2196F3',
	},
	error : {
		fontWeight : 900,
		color : '#FF500F',
	},
	sent : {
		fontWeight : 900,
		color : '#FF500F',
	},
	cancelled : {
		fontWeight : 900,
		color : '#FF500F',
	},
	invalid : {
		fontWeight : 900,
		color : '#FF500F',
	},
	pendingVeryOld : {
		fontWeight : 900,
		color : '#FF500F',
	},
	pendingOld : {
		fontWeight : 900,
		color : '#FF9800',
	},
	normal : {
		color : '#616161',
		fontWeight : 900,
	},
	issued : {
		fontWeight : 900,
		color: '#4CAF50',
	},
	paid : {
		fontWeight : 900,
		color: '#4CAF50',
	},
};

const styles = (theme) => ({
	...invoiceStatusClassNames,
	paper: {
		width: '100%',
		overflowX: 'auto',
		textAlign : 'left',
		boxSizing: 'border-box',
		padding : 20,
		[theme.breakpoints.up('md')]: {
			padding : '10px 20px 20px 20px',
		},
		borderRadius : 0,
	},
	table : {
		width: '100%',
		tableLayout: 'auto',
	},
	row : {
		cursor : 'pointer',
	},
	button: {
		verticalAlign : 'middle',
		padding : '8px 10px',
	},
	stats : {
		padding : '20px 10px 20px 10px',
		borderBottom : '1px solid #ddd',
		marginBottom : 10,
	},
	statGroup : {
		padding : '5px 5px 10px 5px',
		borderBottom : '1px solid #eee',
		marginBottom : 10,
	},
	available : {
		fontWeight : 900,
	},
	invoiceDocument : {
		position : 'absolute',
	},
	invoiceDocumentContainer : {
		position : 'relative',
		display: 'flex',
		alignItems: 'center',
	},
	invoiceIcon: {
		display: 'inline-block',
		width: 40,
		height: 48,
		backgroundImage: `url('${invoiceIcon}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		position: 'relative',
		flexShrink: 0,
		cursor : 'pointer',
	},
	quickbooksIcon: {
		display: 'inline-block',
		width: 40,
		height: 40,
		backgroundImage: `url('${quickbooksLogo}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		position: 'relative',
		flexShrink: 0,
		cursor : 'pointer',
	},

});

const columns = [{
	id: 'trueUpInvoiceId',
	label: 'Invoice #',
}, {
	id: 'customerSort',
	label: 'Customer',
}, {
	id: 'issueDateSort',
	label: 'Issue Date',
}, {
	id: 'trueUpForMonth',
	label: 'For Month',
}, {
	id: 'amountSort',
	label: 'Amount',
}, {
	id: 'attachment',
	label: 'Attachment',
}, {
	id: 'invoicePdf',
	label: 'Invoice PDF',
}, {
	id: 'quickbooksInvoiceUrl',
	label : 'QB Url',
}, {
	id: 'status',
	label: 'Status',
}, {
	id: 'edit',
	label : 'Edit',
	style : {textAlign : 'center'},
	isNotSortable : true,
}];

const statusToDisplay = {
	'pending': 'Pending',
	'issued': 'Issued',
	'invalid': 'Invalid',
	'sent': 'Sent - !NOT ISSUED!',
};


// Create our number formatter.
const moneyFormatter = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
	minimumFractionDigits: 2,
	// the default value for minimumFractionDigits depends on the currency
	// and is usually already 2
});

function TabContainer({ children, dir }) {
	return (
		<Typography component="div" dir={dir} style={{ padding: 8 * 2 }}>
			{children}
		</Typography>
	);
}
TabContainer.propTypes = {
	children: PropTypes.node.isRequired,
	dir: PropTypes.string.isRequired,
};

class TrueUpInvoices extends Component {
	constructor(props) {
		super(props);

		this.state = {
			order: 'desc',
			orderBy: 'trueUpInvoiceId',
			search: '',

			filterMap: {},

			isInvoiceDocumentPopupOpen: false,
			invoiceDocumentsPoppedUp: [],
			isInvoicePdfPopupOpen : false,
			invoicePdfPoppedUp : undefined,

			rows: undefined,
		};
	}

	componentDidMount() {
		const {trueUpInvoices, searchTrueUpInvoices} = this.props;
		const { order, orderBy } = this.state;

		const newState = {};

		if (!trueUpInvoices) {
			searchTrueUpInvoices({
				params : {}
			});
		} else {
			const data = this.formatInvoices({ trueUpInvoices });
			newState.rows = sortTable({data, order, orderBy});
		}

		if (!_.isEmpty(_.keys(newState))) {
			this.setState(newState);
		}
	}

	componentDidUpdate(prevProps, prevState) {
		const {trueUpInvoices } = this.props;
		const { order, orderBy, rows } = this.state;

		const newState = {};

		//- Format the rows when you first get them or they change
		if (prevProps.trueUpInvoices !== trueUpInvoices) {
			const data = this.formatInvoices({ trueUpInvoices });
			newState.rows = sortTable({data, order, orderBy});
		}

		//- Sort
		if (
			prevState.order !== order
			|| prevState.orderBy !== orderBy
		) {
			newState.rows = sortTable({ data: rows, order, orderBy});
		}

		if (prevState.search !== this.state.search) {
			newState.filterMap = this.getFilterMap();
		}

		if (!_.isEmpty(_.keys(newState))) {
			this.setState(newState);
		}
	}

	formatInvoices  = ({ trueUpInvoices }) => {

		const productMap = {
			bulkEthanol : 'Bulk Ethanol',
			e85 : 'E85',
		};

		return trueUpInvoices.map(trueUpInvoice => {
			const {
				bulkCustomerMap,
				resourceMap,
			} = this.props;

			const {
				trueUpInvoiceId,
				productType,
				bulkCustomerId,
				issueDate,
				trueUpForMonth,
				trueUpForYear,
				isCredit,
				total,
				attachmentResourceId,

				quickbooksInvoiceUrl,
				collatedResourceId,

				amount,
				status,

			} = trueUpInvoice;

			const bulkCustomer = bulkCustomerMap[bulkCustomerId] || {name : 'Missing'};
			const bulkCustomerDisplay = `${bulkCustomer.name}`;

			const customerDisplay = (
				<Fragment>
					<div><strong>{bulkCustomerDisplay}</strong></div>
					<div>{productMap[productType]}</div>
				</Fragment>
			);
			const customerSort = `${productType}_${bulkCustomerDisplay}`;

			let issueMoment = moment(issueDate);
			let issueDateSort = issueMoment.format('YYYY-MM-DD');
			let issueDateDisplay = issueMoment.format('ddd, M/D');

			const trueUpForMonthDisplay = moment()
				.month(trueUpForMonth || moment().month())
				.format('MMMM') + `, ${trueUpForYear}`;
			const statusDisplay = statusToDisplay[status] || status;

			const amountDisplay = (
				<Fragment>
					<div>
						<strong>{(isCredit) ? 'Credit' : 'Charge'}</strong>
					</div>
					<div>
						{moneyFormatter.format(total)}
					</div>
				</Fragment>

			);
			const amountSort = `${(isCredit) ? 'credit' : 'invoice'}_${amount}`;

			const resource = resourceMap[attachmentResourceId] || { url : '/'};

			//- Documents
			let invoicePdf = 'PDF';
			let onInvoiceClick = () => { this.onInvoiceClick(collatedResourceId); };

			return {
				trueUpInvoiceId,
				productType,
				customerDisplay,
				customerSort,
				issueDateSort,
				issueDateDisplay,
				trueUpForMonthDisplay,
				trueUpForMonth,
				amountDisplay,
				amountSort,
				attachmentUrl : resource.url,
				collatedResourceId,

				invoicePdf,
				quickbooksInvoiceUrl,
				onInvoiceClick,
				status,
				statusDisplay,
				rowClick: () => {
					this.handleRowClick(trueUpInvoiceId, 'issued');
				}
			};
		});
	};

	getFilterMap = () => {
		const {search, rows} = this.state;
		const filterMap = {};
		rows.forEach(row => {
			if (isFiltered({
				search,
				data: row,
				fields: ['trueUpInvoiceId', 'bulkCustomerDisplay'],
			})) {
				filterMap[row.trueUpInvoiceId] = true;
			}
		});
		return filterMap;
	};

	handleSearch = (event) => {
		this.setState({ search : event.target.value });
	};

	handleSort = (orderBy) => {
		let order = 'desc';
		if (this.state.orderBy === orderBy && this.state.order === 'desc') {
			order = 'asc';
		}
		this.setState({ order, orderBy });
	};

	handleEdit = (trueUpInvoiceId) => {
		this.props.history.push(`/accounting/trueUpInvoice/update/${trueUpInvoiceId}`);
	};

	handleRowClick = (trueUpInvoiceId) => {

		let viewTrueUpInvoice;

		const { trueUpInvoices } = this.props;
		viewTrueUpInvoice = _.find(trueUpInvoices, { trueUpInvoiceId });

		this.setState({
			viewTrueUpInvoice,
			isViewDialogOpen : true,
		});
	};

	handleCloseInvoiceDocumentPopup = () => {
		this.setState({
			isInvoiceDocumentPopupOpen : false,
			invoiceDocumentsPoppedUp : [],
		});
	};

	onInvoiceClick = (resourceId) => {
		this.setState({
			isInvoicePdfPopupOpen : true,
			invoicePdfPoppedUp : resourceId,
		});
	};

	handleCloseInvoicePdfPopup = () => {
		this.setState({
			isInvoicePdfPopupOpen : false,
			invoicePdfPoppedUp : undefined,
		});
	};

	render() {
		const {
			classes,
			canMakeUpdates,
			resourceMap,
		} = this.props;

		const { rows, order, orderBy, filterMap } = this.state;

		if (!rows) {
			return (<div>Loading the true up invoices...</div>);
		}

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<FMPHeadline
						label="True Up Invoices"
						value={this.state.search}
						onChange={this.handleSearch}
						canMakeUpdates={canMakeUpdates}
						buttonText={'Add True Up Invoice'}
						url={'/accounting/trueUpInvoice/add'}
					/>

					<Paper className={classes.paper}>
						<Table size="small" className={classes.table}>
							<EnhancedTableHead
								columnData={columns}
								order={order}
								orderBy={orderBy}
								onRequestSort={this.handleSort}
							/>
							<TableBody>
								{rows.map(row => {
									if (filterMap[row.trueUpInvoiceId]) { return null; }
									return (
										<PureRecordRow
											hover
											className={classes.row}
											key={row.trueUpInvoiceId}
										>
											<TableCell onClick={row.rowClick}>
												{row.trueUpInvoiceId}
											</TableCell>

											<TableCell onClick={row.rowClick}>
												{row.customerDisplay}
											</TableCell>

											<TableCell onClick={row.rowClick}>
												{row.issueDateDisplay}
											</TableCell>

											<TableCell onClick={row.rowClick}>
												{row.trueUpForMonthDisplay}
											</TableCell>
											<TableCell onClick={row.rowClick}>
												{row.amountDisplay}
											</TableCell>

											<TableCell>
												<a href={row.attachmentUrl} target="_blank" rel='noreferrer noopener'>
													<InvoiceDocumentIcon
														invoiceDocument={{
															documentType : 'attachment',
															data : { appendToInvoice : true }
														}}
														onClick={_.noop}
													/>
												</a>
											</TableCell>
											<TableCell>
												{!!row.collatedResourceId &&
												<div
													className={classes.invoiceIcon}
													onClick={row.onInvoiceClick}
												/>
												}
											</TableCell>

											<TableCell>

												{!!row.quickbooksInvoiceUrl &&
												<a href={row.quickbooksInvoiceUrl} target="_blank" rel='noreferrer noopener'>
													<div className={classes.quickbooksIcon}/>
												</a>
												}
											</TableCell>

											<TableCell
												onClick={row.rowClick}
												className={classes[row.status]}
												style={{whiteSpace:'nowrap'}}
											>
												{row.statusDisplay}
											</TableCell>


											{canMakeUpdates &&
											<TableCell
												style={{whiteSpace:'nowrap'}}
											>
												<Button
													className={classes.button}
													onClick={() => this.handleEdit(row.trueUpInvoiceId)}
												>
													Edit
												</Button>
											</TableCell>
											}

										</PureRecordRow>
									);
								})}
							</TableBody>
						</Table>

						<InvoiceDocumentPopup
							open={this.state.isInvoiceDocumentPopupOpen}
							onClose={this.handleCloseInvoiceDocumentPopup}
							invoiceDocuments={this.state.invoiceDocumentsPoppedUp}
							resourceMap={resourceMap}
						/>

						<InvoicePdfPopup
							open={this.state.isInvoicePdfPopupOpen}
							onClose={this.handleCloseInvoicePdfPopup}
							resourceId={this.state.invoicePdfPoppedUp}
							resourceMap={resourceMap}
						/>

					</Paper>
				</Grid>
			</Grid>
		);
	}
}

TrueUpInvoices.propTypes = {
	classes: PropTypes.object.isRequired,
	searchTrueUpInvoices: PropTypes.func.isRequired,
	trueUpInvoices : PropTypes.array,

	showErrors : PropTypes.func.isRequired,

	bulkCustomerMap : PropTypes.object,
	resourceMap : PropTypes.object,

	order: PropTypes.string,
	orderBy: PropTypes.string,
	history : PropTypes.object,
	theme: PropTypes.object.isRequired,
	canMakeUpdates : PropTypes.bool,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	TrueUpInvoicesContainer
])(TrueUpInvoices);